import React from 'react' 
import clsx from 'clsx'
//import I18n from "i18n-js/index.js.erb"
class HousekeepingTypePresenterGeneral extends React.Component {

  constructor(props) {
    super(props);
  }

  /*******************
  * Render functions *
  ********************/

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })
    
    return (
      <div className={tabClasses} id="general">
        <div className="row">
          {this.props.housekeeping_type 
          ?
          this.renderGeneralForm() 
          :
          <div className="text-center"><span className="none">{I18n.t('none')}</span></div>
          }
        </div>
        
      </div>
    )
  }

  renderGeneralForm() {
    return (
      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <p>{this.props.housekeeping_type.code}</p>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <p>{this.props.housekeeping_type.name}</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('description')}</label>
              <div dangerouslySetInnerHTML={{ __html: this.props.housekeeping_type.description }} style={{ maxHeight: '200px', overflowY: 'scroll' }}></div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default HousekeepingTypePresenterGeneral